export const NAVBAR_HEIGHT = 64;
export const SIDEBAR_WIDTH_CLOSED = 64;
export const SIDEBAR_WIDTH_OPEN = 300;
